// contexts/AuthContext.js
'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import { GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCWDfyAW-q14Cq4ozOtVD5_2G0P6Nny3bk",
  authDomain: "ai-copilot-c2a72.firebaseapp.com",
  // authDomain: "aicopilot.duckdns.org",
  projectId: "ai-copilot-c2a72",
  storageBucket: "ai-copilot-c2a72.appspot.com",
  messagingSenderId: "889634801914",
  appId: "1:889634801914:web:cd75263511123e427aa143"
};

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
export const db = getFirestore(app);

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).catch((error) => {
      console.error("Login error:", error);
    });
  };

  const logout = () => {
    signOut(auth).catch((error) => {
      console.error("Logout error:", error);
    });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);
  

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
